<template>
    <div>

        <el-table :row-class-name="tableRowClassName" :data="tableData" style="width: 99.9%" :show-header="false">
            <el-table-column>
                <template slot-scope="scope">
                    <div class="d-flex justify-content-start align-items-center" @click="gotoRegisterRow(scope.row)">
                        <NameInitials :name="scope.row.name"/>
                        <div class="d-flex flex-column my-2 break-name">
                            <h5 class="c-ndarkfour bold mb-1">
                                {{ scope.row.name | formatName }}
                            </h5> 
                            <div class="d-flex c-nmidone medium mb-1 break">
                                {{ partnerType(scope.row) | formatName }}
                                <caption class="ml-1 mb-0 c-ndarkfour bgc-nlightone partner-caption">
                                    {{ scope.row.associateType == 'Sócio' ? 'PF' : 'PJ' }}
                                </caption>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="100px">
                <template slot-scope="scope">
                    <div class="d-flex justify-content-end align-items-center" @click="gotoRegisterRow(scope.row)">
                        <div class="mr-3">
                            <PartnerOrProcuratorStatus :status="scope.row.registerComplete"/>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="50px">
                <template slot-scope="scope">
                    <el-dropdown trigger="click" class="partner-dropdown">
                        <span>
                            <DropdownIcon />
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width: 250px">
                            <ActionBtnItemsContainer :withoutBottomLine="!$store.state.user.userAdm">
                                <el-dropdown-item>
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="gotoRegisterRow(scope.row)">
                                        <Eye class="mr-2" :size="'18'" :color="'#A1A8B8'" />
                                        Ver cadastro
                                    </span>
                                </el-dropdown-item>
        
                                <el-dropdown-item>
                                    <span
                                        class="c-ndarkthree medium pl-3 d-flex align-items-center"
                                        @click="handleChangePartnerProfile(scope.row)"
                                        v-if="$store.state.user.userAdm && !scope.row.registerComplete"
                                    >
                                        <User class="mr-2" :size="'18'" :color="'#A1A8B8'" />Alterar perfil do sócio
                                    </span>
                                </el-dropdown-item>
                            </ActionBtnItemsContainer>
                            <ActionBtnItemsContainer withoutBottomLine v-if="$store.state.user.userAdm">
                                <el-dropdown-item>
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleDeletePartner(scope.row)">
                                        <Delete class="mr-2" :size="'16'" color="#A1A8B8"/>
                                        Excluir o sócio
                                    </span>
                                </el-dropdown-item>
                            </ActionBtnItemsContainer>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <el-table-column slot="empty" />
        </el-table>
        <PartnerDelete :dialogVisible="dialogVisibleDelete" @closeModal="dialogVisibleDelete = $event" @deletePartner="requestDeletePartner" />
    </div>
</template>

<script>
import NameInitials from '@/components/icons/NameInitials'
import PartnerOrProcuratorStatus from '@/components/status/PartnerOrProcuratorStatus'
import statusCodesBlockInput from '@/utils/statusCodesBlockInput'
import DropdownIcon from '@/components/icons/Dropdown'
import Eye from '@/components/icons/Eye'
import User from '@/components/icons/User'
import Delete from '@/components/icons/Delete'
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer.vue'
import PartnerDelete from '@/components/modals/PartnerDelete'
import deletePartnerPF from '@/api/deletePartnerPF'
import deletePartnerPJ from '@/api/deletePartnerPJ'

export default {
    components: {
    NameInitials,
    PartnerOrProcuratorStatus,
    DropdownIcon,
    Eye,
    User,
    Delete,
    ActionBtnItemsContainer,
    PartnerDelete,
},
    props: {
        tableData: {
            required: true
        }
    },
    data() {
        return {
            dialogVisibleDelete: false,
            partnerToDelete: {}
        }
    },
    computed: {
        companyRegisterComplete() {
            return !this.$store.state.user.userAdm && statusCodesBlockInput.includes(this.$store.state.register.company.cnpj.registerComplete) ? true : false
        }
    },
    methods: {
        partnerType(row) {
            if (row.associateType || row.profession) {
                return row.associateType == 'Procurador' ? 'Procurador' : row.profession
            } else {
                return 'Sócio Pessoa Jurídica'
            }
        },
        tableRowClassName({row}) {
            if (row.registerComplete == '0') {
                return 'pending-border'
            }
            return ''
        },
        formatTooltip(value) {
            let val = (value / 100).toFixed(2).toString().replace('.', ',')
            return `R$ ${val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
        },
        gotoRegisterRow(row) {
            this.$store.commit('register/setPartner', row)
            const routePrefix = this.$store.state.user.userAdm ? `/partner/${this.$route.params.idCNPJ}` : `/company/register/${this.$route.params.idCNPJ}/partner`
            if (row.associateType == 'Sócio' || row.profession) return this.$router.push(`${routePrefix}/pf/${row.id}/0`)
            if (row.associateType == 'Procurador') return this.$router.push(`${routePrefix}/procurator/${row.id}/0`)
            else this.$router.push(`${routePrefix}/pj/${row.id}/0`)
        },
        handleChangePartnerProfile(row) {
            const partnerProfile = (row.associateType == 'Sócio' || row.profession) ? 'pf' : 'pj'
            this.$store.commit('register/setPartner', row)
            this.$emit('requestPartnerProfileChange', partnerProfile)
        },
        handleDeletePartner(partner) {
            this.partnerToDelete = partner
            this.dialogVisibleDelete = true
        },
        async requestDeletePartner() {
            // this.loadingBtn = true
            console.log(this.partnerToDelete)
            
            const { id, associateType, profession } = this.partnerToDelete
            const partnerType = ['Sócio', 'Procurador'].includes(associateType) || profession ? 'pf' : 'pj'

            if (partnerType === 'pf') {
                await deletePartnerPF(id)
            }

            if (partnerType === 'pj') {
                await deletePartnerPJ(id)
            }

            // this.loadingBtn = false

            this.$emit('requestPartners')
            this.dialogVisibleDelete = false
        }
    }
}
</script>

<style scoped>
.partner-caption {
    padding: 4px 8px;
    border-radius: 26px;
}

.partner-dropdown {
    display: inline !important;
}

</style>